<template>
  <div class="container">
    <header class="jumbotron">
      <h3>Transações</h3>
    </header>

    <div class="col-md-5">
      <div class="card card-container">
          <Form @submit="handleFilter" :validation-schema="schema">
          <div>
            <div v-if="showAdminBoard" class="form-group">
              <label for="user">Usuário</label>              
              <Field name="user" as="select" multiple class="form-control" v-model="formData.user" >
                <option
                  v-for="i in userOptions"
                  :value="i.value"
                  :key="i.value"
                >
                  {{ i.text }}
                </option>
              </Field>
              <ErrorMessage name="user" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="status">Status</label>
              <!-- <Field name="typePix" type="text" class="form-control" /> -->
              <Field name="status" as="select" class="form-control" v-model="formData.status">
                <option value="">Selecione o Status</option>
                <option value="2">Confirmado</option>
                <option value="-1">Erro</option>
                <option value="0">Em processamento</option>
              </Field>
              <ErrorMessage name="typePix" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="cpf">CPF</label>
              <Field name="cpf" type="text" class="form-control" v-model="formData.cpf" />
              <ErrorMessage name="cpf" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="pixkey">Chave Pix</label>
              <Field name="pixkey" type="text" class="form-control" v-model="formData.pixkey" />
              <ErrorMessage name="pixkey" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="datestart">Data Inicio (AAAA-MM-DD)</label>
              <Field name="datestart" type="text" class="form-control" v-model="formData.datestart" />
              <ErrorMessage name="datestart" class="error-feedback" />
            </div>
            <div class="form-group">
              <label for="dateend">Data Final (AAAA-MM-DD)</label>
              <Field name="dateend" type="text" class="form-control" v-model="formData.dateend"/>
              <ErrorMessage name="dateend" class="error-feedback" />
            </div>

            <div class="form-group">
              <button class="btn btn-primary btn-block" :disabled="loading">
                <span
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Filtrar
              </button>
            </div>
          </div>
        </Form>
        <div >
          <button @click="exportCSV" class="btn btn-secondary btn-block" :disabled="loading">
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            Exportar
          </button>
        </div>
        </div>
      </div>
    <table>
      <thead>
        <tr>
          <th></th>
          <th>ID</th>
          <th>RoyalPagID</th>
          <th>Usuário</th>
          <th>CPF</th>
          <th>Tipo PIX</th>
          <th>Chave PIX</th>
          <th>Data</th>
          <th>Status</th>
          <th>Mensagem</th>
          <th style="text-align: right; text-wrap: nowrap">
            Valor (R$ {{ total.toFixed(2) }})
          </th>
        </tr>
      </thead>
      <tbody style="font-size: 13px">
        <tr v-for="(row, index) in rows" :key="`transaction-${index}`">
          <td style="text-align: center">
            <div class="td-flex">
              <a
                :href="`https://dashboard.royalpag.com/app/receipts#/withdraw/${row.royalpagid}`"
                target="_blank"
                ><font-awesome-icon icon="file-pdf"
              /></a>
              
              <a v-if="row.hasComprovante"
                :href="`https://comprovante-gg.royalpag.com/comprovantes/${row.comprovanteid}`"
                target="_blank"
                ><font-awesome-icon icon="file" /></a>
              <a v-if="!row.hasComprovante"
                :href="`proof/${row.comprovanteid}`"
                ><font-awesome-icon icon="file" style="color: #2bff00;" /></a>
            </div>
          </td>
          <td>{{ row.id }}</td>
          <td>{{ row.royalpagid }}</td>
          <td>{{ row.user }}</td>
          <td>{{ row.cpf }}</td>
          <td>{{ row.pixType }}</td>
          <td>{{ row.pixKey }}</td>
          <td style="text-wrap: nowrap">{{ row.date }}</td>
          <td>{{ row.status }}</td>
          <td>{{ row.message }}</td>
          <td style="text-align: right; text-wrap: nowrap">
            R$ {{ row.value.toFixed(2) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import TransactionService from "../services/transaction.service";
import UserService from "../services/user.service";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
  name: "Transactions",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({});
    return {
      formData: {
        user:"",
        status:"",
        cpf:"",
        pixkey:"",
        datestart:"",
        dateend:"",
      },
      successful: false,
      loading: false,
      perPage: 3,
      currentPage: 1,
      filter: "",
      schema,
      rows: [],
      userOptions: [],
      total: 0,
    };
  },
  mounted() {
    if (!this.currentUser || !this.loggedIn) {
      this.$root.logOut();
    }
    if (this.loggedIn) {
      if (this.showAdminBoard) {
        UserService.getListUser().then(
          (response) => {
            if (response.data.result) {
              this.userOptions = response.data.data;
            }
          },
          (error) => {
            this.userOptions = [];
            console.log(
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString()
            );
          }
        );
      }
      TransactionService.getTransactions().then(
        (response) => {
          if (response.data.result) {
            this.rows = response.data.data;
            this.total = this.rows.reduce((a, b) => a + b.value, 0);
          }
        },
        (error) => {
          this.rows = [];
          confirm.error(error);
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
        }
      );
    }
  },
  computed: {
    loggedIn() {
      return (
        this.$store.state.auth.status.loggedIn &&
        this.$store.state.auth.user.validOTP
      );
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser["roles"]) {
        return this.currentUser["roles"].includes("ROLE_ADMIN");
      }

      return false;
    },
  },
  methods: {
    handleFilter(data) {
      console.log("handleFilter");
      TransactionService.getTransactionFiltered(data).then(
        (response) => {
          if (response.data.result) {
            this.rows = response.data.data;
            this.total = this.rows.reduce((a, b) => a + b.value, 0);
          }
        },
        (error) => {
          this.rows = [];
          confirm.error(error);
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
        }
      );
      this.message = "";
      this.successful = false;
      this.loading = false;
    },
    exportCSV() {
      TransactionService.getTransactionCSV(this.formData).then(
        (response) => {
          console.log(response.data.result);
          console.log(response.data.filename);
          window.open(response.data.filename, '_blank');

        },
        (error) => {
          this.rows = [];
          confirm.error(error);
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
        }
      );
      this.message = "";
      this.successful = false;
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.td-flex {
  display: flex;
  column-gap: 3px;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

th {
  background-color: #dddddd;
}
</style>